// extracted by mini-css-extract-plugin
module.exports = {"OurValues":"styles_OurValues__5x_7A","height":"styles_height__E_kLU"};